import React, { useState, useEffect } from "react";
import { Table, Button, Space, Popconfirm, message,Typography ,Row,Col} from "antd";
import { BrowserRouter as Router, Route, Routes, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useSelector } from "react-redux";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import FlowUI from "./FlowUI"; // Import your FlowUI component
import ApiService from "../Components/apiService";
import { BASE_URL } from "../Components/Constant";
import { Navigate } from "react-router-dom";
import FlowDetailsModal from "../NewFlows/FlowDetailsModal";

const {Title}=Typography;

const FlowsTable = (object) => {
  const [flows, setFlows] = useState([]);
  const [isCreatingFlow, setIsCreatingFlow] = useState(false);
  const [isEditingFlow,setIsEditingFlow] = useState(false);
  const [selectedFlowData,setSelectedFlowData] = useState({});
  const [pageSize, setPageSize] = useState(10);
  const navigate = useNavigate();
  const [isModalForFlowDetailsVisible,setIsModalForFlowDetailsVisible] = useState(false);
  const security = useSelector((state) => state.data.items[0]);

  useEffect(() => {
    if (isCreatingFlow) {
        if(security?.system_settings?.flow.create===false){
            message.error('You dont have permission to create ');
            return;
        }
      setIsModalForFlowDetailsVisible(true);
    }
    if (isEditingFlow && selectedFlowData && Object.keys(selectedFlowData).length > 0 ) {
      if(security?.system_settings?.flow.edit===false){
        message.error('You dont have permission to edit ');
        return;
    }
      console.log('editing floww:: ',selectedFlowData);
      navigate('/Flows',{state: {selectedFlowData:selectedFlowData}});
    }

  }, [isCreatingFlow, isEditingFlow, selectedFlowData]);
  
  useEffect(() => {
    // Fetch flows from the API when the component mounts
    fetchFlows();
  }, []);

  const fetchFlows = async () => {
    try {
      const apiService = new ApiService(
        `${BASE_URL}/get_flow/${object.object.name}`,
        { "Content-Type": "application/json" },
        "GET"
      );
      const response = await apiService.makeCall();
        if (response && Object.keys(response).length === 0) {
            setFlows([]); // Set empty array if no flows are found
            return; // Exit early if no flows
          }
        setFlows(
          response?.map((flow) => ({
            ...flow,
            key: flow?._id, // Map `_id` to `key` for Ant Design table
          })) 
        );
    } catch (error) {
      console.error("Error fetching flows:", error);
    //   message.error("Failed to fetch flows.");
    }
  };

  const handleEdit = async (record)=>{
    setIsEditingFlow(true);
    try{
        const apiService = new ApiService(
        `${BASE_URL}/get_flow_with_relations/${record._id}`,
        { "Content-Type": "application/json" },
        "GET"
        );
        const response = await apiService.makeCall();
        if (!response || Object.keys(response).length === 0) {
            setSelectedFlowData([]); // Set empty array if no flow Data is found are found
          } else {
            setSelectedFlowData(response); // Store the fetched data in the state
            console.log('editing flow data::',response);
          }
        } catch (error) {
        console.error("Error fetching flows:", error);
    //   message.error("Failed to fetch flows.");
    }
  }
  const handleDelete = async (id) => {
    try {
      const apiService = new ApiService(
        `${BASE_URL}/mt_flows/${id}`,
        { "Content-Type": "application/json" },
        "DELETE"
      );
      await apiService.makeCall();
      message.success("Flow deleted successfully.");
      fetchFlows(); // Refresh the table after deletion
    } catch (error) {
      console.error("Error deleting flow:", error);
      message.error("Failed to delete flow.");
    }
  };

  const columns = [
    {
      title: "Label",
      dataIndex: "label",
      key: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
      render: (text, record) => (
        <Button
          type="link"
          onClick={() => handleEdit(record)} // Trigger handleEdit when clicked
          style={{ padding: 0 }} // Optional: Remove extra padding for a cleaner look
        >
          {text}
        </Button>
      ),  
    },
    {
      title: "Api Name",
      dataIndex: "name",
      key: "apiName",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
    },
    
    {
      title: "Event",
      dataIndex: "event",
      key: "event",
      sorter: (a, b) => a.event.localeCompare(b.event),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Space>
          <Button
            icon={<EditOutlined />}
            type="link"
            onClick={() => handleEdit(record)}
          >
            
          </Button>
          <Popconfirm
            title="Are you sure you want to delete this flow?"
            onConfirm={() => handleDelete(record.key)}
            okText="Yes"
            cancelText="No"
          >
            <Button icon={<DeleteOutlined />} type="link" danger>
              
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  // if (isCreatingFlow || (isEditingFlow && selectedFlowData)) {
  //   setIsModalForFlowDetailsVisible(true);
  //   // navigate('/Flows');

  //   // return <FlowUI setSelectedFlowData={setSelectedFlowData} selectedFlowData={selectedFlowData} object={object} setIsCreatingFlow={setIsCreatingFlow} isEditingFlow={isEditingFlow} setIsEditingFlow={setIsEditingFlow} fetchFlows={fetchFlows} />;
  // }

  const handleNextForFlowScreen = (values)=>{
    console.log('flow details..::',values);
    // console.log('flww dis:',object);
    navigate('/Flows',{state: {formData: values,object: object}});
  }
  return (
    <div>
     

         <Row justify="space-between" align="middle" style={{ marginBottom: 10 }}>
                                    <Col>
                                        <Title level={4} >Flows</Title>
                                    </Col>
                                    <Col>
                                        <Button type="primary" onClick={() => setIsCreatingFlow(true)}>Create New Flow</Button>
                                    </Col>
                                </Row>
      <Table
        dataSource={flows}
        columns={columns}
        rowKey="key"
        scroll={{ x: 'max-content', y: 550 }}
        pagination={{
              pageSize: pageSize,
              showSizeChanger: true,
              pageSizeOptions: ['10', '20', '50', '100'],
              onChange: (page, pageSize) => {
                setPageSize(pageSize);
              },              
              showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
            }}
      />
      {isModalForFlowDetailsVisible && (
        <FlowDetailsModal
        showModal={isModalForFlowDetailsVisible}
        setShowModal={setIsModalForFlowDetailsVisible}
        handleNext={handleNextForFlowScreen}
        object={object}
        setIsCreatingFlow={setIsCreatingFlow}
        />
      )}

    </div>
  );
};

export default FlowsTable;